export let mailFilter = "DlXHzc";
export let allFilter = "BnX6te";
export let sortBySize = "gihxLe";
export default {mailFilter,allFilter,sortBySize};